@if (block.data.heading) {
    <h2 [innerText]="block.data.heading" class="logo-slider__title mt-5 mb-3"></h2>
}
@if (block.content) {
    <swiper #logoCarouselSwiper [config]="swiperConfig" class="logo-slider__carousel">
        @for (logo of block.content; track trackByFn($index, logo)) {
            <swiper-slide class="">
                <div class="logo-slider__logo">
                    <img
                        [src]="logo.data.image | cdn"
                        [alt]="logo.data.imageAlt || 'Logo image'"
                        class="logo-slider__image" />
                </div>
            </swiper-slide>
        }
    </swiper>
}
